/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTaskboxPermissionRequest
 */
export interface UpdateTaskboxPermissionRequest {
    /**
     * Whether the permission is active or not
     * @type {boolean}
     * @memberof UpdateTaskboxPermissionRequest
     */
    assignee: boolean;
}

/**
 * Check if a given object implements the UpdateTaskboxPermissionRequest interface.
 */
export function instanceOfUpdateTaskboxPermissionRequest(value: object): value is UpdateTaskboxPermissionRequest {
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    return true;
}

export function UpdateTaskboxPermissionRequestFromJSON(json: any): UpdateTaskboxPermissionRequest {
    return UpdateTaskboxPermissionRequestFromJSONTyped(json, false);
}

export function UpdateTaskboxPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskboxPermissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assignee': json['assignee'],
    };
}

export function UpdateTaskboxPermissionRequestToJSON(json: any): UpdateTaskboxPermissionRequest {
    return UpdateTaskboxPermissionRequestToJSONTyped(json, false);
}

export function UpdateTaskboxPermissionRequestToJSONTyped(value?: UpdateTaskboxPermissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignee': value['assignee'],
    };
}

